import { Share } from '@/icons'
import clsx from 'clsx'

import { onImageError } from '@/utils/sentry/onImageError'

import { Link } from '@/components/CustomLink'
import { Image } from '@/components/Image'

type Props = {
	className?: string
	'data-testid'?: string
	imageSrc?: { url?: string; dimensions: { width?: number; height?: number } }
	imageAlt: string
	linkURL: {
		href: string
		target?: '_self' | '_blank'
	}
	caseStudyURL?: {
		href?: string | null
		target?: '_self' | '_blank'
		isExternal?: boolean
		label?: string
	}
	title?: string
	bgColor?: string
	variant?: 'light' | 'dark'
}

export function ShowcaseCard({
	className,
	imageSrc,
	imageAlt,
	linkURL,
	title,
	bgColor,
	caseStudyURL,
	'data-testid': testId,
	variant = 'light'
}: Props) {
	return (
		<div
			className={clsx(
				className,
				variant === 'light' ? 'text-white' : 'text-bc-black',
				'flex-col',
				'flex w-full self-stretch',
				'hover:shadow-lg',
				'rounded-lg'
			)}
			data-testid={testId}
			style={{ background: bgColor }}
		>
			<div className="flex flex-col flex-1 px-6 md:px-6 py-4 text-current break-words border-b border-[#DBDFE7] ">
				<Link href={linkURL.href} target={linkURL.target}>
					<div className="flex-1">
						{title && (
							<h3 data-testid="card-title" className="text-lg font-medium">
								{title}
							</h3>
						)}
					</div>
				</Link>
				{caseStudyURL?.href && (
					<div className=" pt-1">
						<Link
							href={caseStudyURL?.href}
							className="text-xs leading-[22px] text-bc-blue font-medium flex row-auto items-center"
							target={caseStudyURL.isExternal ? caseStudyURL?.target : ''}
							dataTestId="case-study-link"
						>
							{caseStudyURL?.label}
							{caseStudyURL?.isExternal && (
								<div className=" ml-2">
									<Share />
								</div>
							)}
						</Link>
					</div>
				)}
			</div>
			{imageSrc?.url && (
				<Link href={linkURL.href} target={linkURL.target}>
					<Image
						src={imageSrc.url.startsWith('//') ? `https:${imageSrc.url}` : imageSrc.url}
						alt={imageAlt}
						width={imageSrc.dimensions.width}
						height={imageSrc.dimensions.height}
						onError={onImageError}
						className={clsx('w-full', 'aspect-[4/3]', 'object-top', 'object-cover', 'rounded-b-lg')}
					/>
				</Link>
			)}
		</div>
	)
}
